<section class="hd-nodal-lines-cheat-sheet-page">
  <!-- Controls -->
  <e-card2 class="hd-nodal-lines-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-nodal-lines-cheat-sheet-page__controls" aria-label="Nodal lines cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-nodal-lines-cheat-sheet-page__divider"></span>

      <button type="button" class="hd-nodal-lines-cheat-sheet-page__control" (click)="print()" aria-label="Print de cheat sheet">
        <i eIcon icon="print"></i>
        <span>Print</span>
      </button>
    </div>
  </e-card2>

  @if (pageTitle()) {
    <h2 class="hd-nodal-lines-cheat-sheet-page__title">{{ pageTitle() }}</h2>
  }

  <div class="hd-nodal-lines-cheat-sheet-page__deck">
    <div class="hd-nodal-lines-cheat-sheet-page__grid">
      @for (card of cards; track card.side + card.line) {
        <hd-nodal-line-card [line]="card.line" [side]="card.side" />
      }
    </div>
  </div>
</section>
